export enum UserFlag {
  ENABLE_AGENCY_PARTNER_STACK = 'enable_agency_partner_stack',
  ENABLE_MOBILE_BANNER_EXPERIMENT_SEQUEL = 'enable_mobile_banner_experiment_sequel',
  MANDATORY_EMAIL_VERIFICATION = 'mandatory_email_verification',
  ENABLE_AI_INTERVIEWS_GENERAL = 'enable_ai_interviews_general',
  ENABLE_AI_INTERVIEWS_HOME_TAB = 'enable_ai_interviews_home_tab',
  ENABLE_FIN_AI_EXPERIMENT = 'enable_fin_ai_experiment',
  DISABLE_BRAZE_NOTIFICATIONS_FOR_WEB_VIEW = 'disable_braze_notifications_for_web_view',
  ENABLE_BRAZE_PUSH_NOTIFICATIONS = 'enable_braze_push_notifications',
}

export enum AccountFlag {
  ENABLE_FACELIFTING_FOR_CONFERENCE = 'enable_facelifting_for_conference',
  ENABLE_IG_RECURRING_NOTIFICATION = 'enable_ig_recurring_notification',
  ENABLE_INBOX = 'enable_inbox',
  ENABLE_INDIAN_CUSTOMERS_3DS_RESUBSCRIPTION = 'enable_indian_customers_3ds_resubscription',
  ENABLE_LC_STATISTICS = 'enable_lc_statistics',
  ENABLE_WEBVIEW = 'enable_webview',
  FETCH_STORIES_FROM_CDN = 'fetch_stories_from_cdn',
  UKRAINE_2022_SUPPORT = 'ukraine_2022_support',
  UKRAINE_2022_SUPPORT_SHOW_MODAL = 'ukraine_2022_support_show_modal',
  WA_CLOUD_API_RECONNECT_ALLOWED = 'wa_cloud_api_reconnect_allowed',
  ENABLE_DM_LIST_IMPROVEMENTS = 'enable_dm_list_improvements',
  ENABLE_IG_CROSS_CHANNEL_BUTTON = 'enable_ig_cross_channel_button',
  ENABLE_WA_CATALOG = 'enable_wa_catalog',
  NOT_CHECKED_FOR_IMPORT_UNIFIED_SUBSCRIBERS = 'not_checked_for_import_unified_subscribers',
  ENABLE_GOOGLE_SHEETS_ACTION_CONFIG_FALLBACK = 'google_sheets_action_config_fallback',
  ENABLE_HIGHLIGHT_INSTRUMENT = 'enable_highlight_instrument',
  ENABLE_AI_BUSINESS_CONTEXT = 'enable_ai_business_context',
  ENABLE_HIGHLIGHT_FOR_TIKTOK = 'enable_highlight_for_tiktok',
  ENABLE_AI_PAYWALL = 'enable_ai_paywall',
  ENABLE_CTA_IG_REG_FLOW_EXPERIMENT = 'enable_cta_ig_reg_flow_experiment',
  DISABLE_CTA_IG_REG_FLOW_EXPERIMENT = 'disable_cta_ig_reg_flow_experiment',
  ENABLE_TIKTOK_ADS_TRIGGER = 'enable_tiktok_ads_trigger',
  ENABLE_IN_APP_CARD_ATTACHMENT = 'enable_in_app_card_attachment',
  DISABLE_IN_APP_CARD_ATTACHMENT = 'disable_in_app_card_attachment',
  ENABLE_AI_STEP_STATS = 'enable_ai_step_content_stat_display',
  ENABLE_BILLING_ADDRESS_ONLY_US = 'enable_billing_address_only_us',
  DISABLE_BILLING_ADDRESS_ONLY_US = 'disable_billing_address_only_us',
  ENABLE_AI_ALWAYS_ON_AUTOMATION = 'enable_ai_always_on_automation',
  ENABLE_IN_APP_CHECKOUT_BRAZIL = 'in_app_checkout_brazil',
  ENABLE_IN_APP_CHECKOUT_BRAZIL_REGFLOW = 'in_app_checkout_brazil_regflow',
  ENABLE_NEW_HOMETAB_INSIGHTS = 'enable_new_hometab_insights',
  ENABLE_NEW_HOMETAB_INSIGHTS_MODALS = 'enable_new_hometab_insights_modals',
  ENABLE_EASY_BUILDER_RECOMMENDATIONS = 'enable_easy_builder_recommendations',
  ENABLE_WA_PRICING_UPDATE = 'enable_whatsapp_per_message_pricing_model',
  ENABLE_NEW_START_FROM_SCRATCH = 'enable_new_start_from_scratch',
  DISABLE_NEW_START_FROM_SCRATCH = 'disable_new_start_from_scratch',
  ENABLE_AI_ALWAYS_ON_AUTOMATION_FEED_COMMENT = 'enable_ai_always_on_automation_feed_comment',
  ENABLE_PRIVATE_REPLY_TO_FOLLOW = 'enable_private_reply_to_follow',
  ENABLE_IG_FOLLOW_REPLY_TRIGGER = 'enable_ig_follow_reply_trigger',
  ENABLE_EASY_BUILDER_NEW_CGT_ORDER = 'enable_easy_builder_new_cgt_order',
  ENABLE_IG_SELF_MESSAGE = 'enable_ig_self_message',
  IG_SELF_MESSAGE_ALLOWED = 'ig_self_message_allowed',
  ENABLE_SOCIAL_ENGAGEMENT = 'enable_ai_automation_social_engagement',
  ENABLE_NON_EMPTY_WALLET_AS_BLOCKER_FOR_DELETION = 'enable_non_empty_wallet_as_blocker_for_deletion',
  ENABLE_UPGRADE_FROM_TRIAL = 'enable_upgrade_from_trial',
  ENABLE_IG_SUMMIT_TICKET_LAUNCH_BANNER = 'enable_ig_summit_ticket_launch_banner',
  ENABLE_AI_AUTOMATION_KNOWLEDGE_NEW_API = 'enable_ai_automation_knowledge_new_api',
  ENABLE_NEW_RECOMMENDATION_SCREEN_V2 = 'enable_new_recommendation_screen_v2',
  DISABLE_NEW_RECOMMENDATION_SCREEN_V2 = 'disable_new_recommendation_screen_v2',
  ENABLE_IGSID_EXPORT = 'enable_igsid_export',
  ENABLE_FB_MARKETING_MESSAGES = 'enable_fb_marketing_messages',
}
